import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
    // === LEFT SIDE ===
    @Input() title: string = '';
    @Input() description: string = '';

    @Input() entityOptions?: any[];
    @Input() yearOptions?: number[];
    @Input() entitiesOptions?: string[];
    @Input() filtersOptions?: string[];

    @Input() dedicatedAdminOptions?: any[];
    @Input() selectedDedicatedAdmin?: any;
    @Input() dedicatedAdminDisabled: boolean = false;

    @Input() selectedEntity?: any;
    @Input() selectedYear?: number;
    selectedEntities: string[] = [];
    selectedFilters: string[] = [];

    // Emitted when the selected entity changes (two-way binding support)
    @Output() selectedEntityChange = new EventEmitter<any>();
    // Emits the raw change event from the entity dropdown (custom logic in parent)
    @Output() entityChange = new EventEmitter<any>();
    // Emitted when the selected year changes (two-way binding support)
    @Output() selectedYearChange = new EventEmitter<number>();
    // Emits the raw change event from the year dropdown (custom logic in parent)
    @Output() yearChange = new EventEmitter<any>();
    // Emits the new value when two-way binding is used with [(selectedDedicatedAdmin)]
    @Output() selectedDedicatedAdminChange = new EventEmitter<any>();
    // Emits the raw change event from the dedicated admin dropdown (for custom logic in parent)
    @Output() dedicatedAdminChange = new EventEmitter<any>();

    // === RIGHT SIDE ===
    @Input() showQuestionnaireIcon: boolean = false;
    @Input() knobValue?: number;
    @Input() rightDropdownOptions?: string[];
    @Input() rightDropdownSelected?: string;
    @Input() rightText?: string;

    @Input() showCommentIcon: boolean = false;
    @Input() showAttachmentIcon: boolean = false;

    // Event emitter used to notify the parent component to open a modal dialog.
    @Output() openModal = new EventEmitter<void>();

    /**
     * Emits an event to open a modal.
     * Called when the related UI element (e.g., button) is clicked.
     */
    onOpenModalClick(): void {
        this.openModal.emit();
    }

    /**
     * Handles the change of the selected entity from the dropdown.
     * - Emits the new value via `selectedEntityChange` to keep the parent in sync (two-way binding).
     * - Also emits the raw change event via `entityChange` so the parent can execute custom logic (e.g., reload data).
     *
     * @param event Event object emitted by p-dropdown (contains the selected value and other info).
     */
    handleEntityChange(event: any): void {
        this.selectedEntityChange.emit(this.selectedEntity); // Updates the parent's selectedEntity via [(selectedEntity)]
        this.entityChange.emit(event); // Triggers custom logic in parent via (entityChange)
    }
}
